import { apiPost } from "../../client";
import { ApiConfig } from "../../config";

export interface TelemedMeetingSession {
  domain: string;
  room_name: string;
  jwt: string;
  expires_at: string;
  invite_url: string;
}

export interface TelemedParticipantSession {
  domain: string;
  room_name: string;
  jwt: string;
  display_name: string;
  expires_at: string;
}

export type TreatmentId = string | number;

export async function createTelemedMeeting(
  treatmentId: TreatmentId,
): Promise<TelemedMeetingSession> {
  const numericId = Number.parseInt(String(treatmentId), 10);
  if (!Number.isFinite(numericId)) {
    throw new Error("รหัสการรักษาไม่ถูกต้อง");
  }
  return apiPost<TelemedMeetingSession>(
    `${ApiConfig.MEETING_BASE}/meetings/${numericId}/`,
  );
}

export async function joinTelemedMeeting(
  meetingId: string,
  token: string,
  displayName = "",
): Promise<TelemedParticipantSession> {
  return apiPost<TelemedParticipantSession>(
    `${ApiConfig.MEETING_BASE}/meetings/${meetingId}/join/`,
    {
      token,
      display_name: displayName,
    },
    { withAuth: false },
  );
}
